export const USER_PROPERTY_GROUP_NAME = 'Custom';

export const monitoringItemTypes = {
  string: 'string',
  number: 'number',
  bool: 'bool',
  json: 'json'
};
